import {fetchWrapper} from "../../helpers/fetch.wrapper";
const baseUrl = process.env.REACT_APP_BASE_URL;
export const employeeRecordService = {
   employeeRecordStatus

}

async function employeeRecordStatus() {

    return fetchWrapper.get(`${baseUrl}/employee/profile`)
        .then(response => {
            return response;
        });
}



